// Import React
import React, {FC, useCallback, memo, useState} from 'react';
import styled from 'styled-components';
import colors from '../../../config/colors';
import ErrorMessage from '../ErrorMessage';

// Interface Props
interface Props {
  type?: string,
  onInputChange?: any;
  defaultValue?: any,
  inputPlaceholder?: string;
  justRead?: boolean;
  required?: boolean;
  theme?: string,
  icon?: boolean,
  svgIcon?: string;
  showPassword?: any;
  resetButton?: boolean;
  fakeInput?: string;
  [x:string]: any;
  maxChars?: number,
  maxCharsMessage?: string,
}

// Form Input
const FormInput: FC<Props> = props => {
  const {defaultValue, inputPlaceholder, onInputChange, type, justRead, required, theme, svgIcon, icon, showPassword, resetButton, fakeInput,maxChars,maxCharsMessage,  ...otherProps} = props;
    

    const [maxCharsLimit, setMaxCharsLimit] = useState<boolean>(false)

    const handleChangeInputField = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
    
      if(maxChars && value && (value.length > maxChars)) {
        
        setMaxCharsLimit(true);
      }
      onInputChange(value);
    },[maxChars, onInputChange]);

    const reset = () => {
      onInputChange('');
    }

    return (
      <InputWrapper className={`${theme ==='white' ? 'whiteBg' : ''} ${fakeInput ? 'fakeInput' : ''}`}>
        {fakeInput ? <FakeInput>{fakeInput}</FakeInput> : null}
        <Input
          type={type}
          value={defaultValue}
          onChange={handleChangeInputField}
          placeholder={''}
          readOnly={justRead}
          {...otherProps}
        />
        {!defaultValue ?
          <Placeholder>
            {inputPlaceholder} {required ? <sup>*</sup> : null}
          </Placeholder>
        : null}
        {showPassword ?
          <Icon onClick={showPassword}><svg><use xlinkHref={`${svgIcon}`} /></svg></Icon>
        : null}
        {icon ?
          <Icon><svg><use xlinkHref={`${svgIcon}`} /></svg></Icon>
        : null}
        {resetButton && defaultValue ?
          <Icon onClick={reset}>
            <svg><use xlinkHref={`#close`} /></svg>
          </Icon>
        : null}

        {maxCharsLimit ? <ErrorMessageChar>{maxCharsMessage}</ErrorMessageChar> : null}
        
      </InputWrapper>
    );
}

const InputWrapper = styled.div`
  position: relative;
  margin: 0 0 10px;
  .select-wrapper__clear {
      display: block;
  }

  &.whiteBg {

    input {
      background: ${colors.WHITE};
    }
  }
  &.fakeInput {
    input, span {
      padding-left: 168px;
    }
  }
`;

const FakeInput = styled.div`
  position: absolute;
  padding-left: 14px;
  padding-right: 3px;
  border-right: 1px solid rgba(#afafaf, 0.5);
  background: ${colors.GRAY_LIGHT};
  font-size: 16px;
  display: flex;
  align-items: center;
  top: 25px;
  transform: translateY(-50%);
  left: 0; 
  height: 50px;
  font-family: "Gilroy-Medium";
`;

const Input = styled.input`
  display: block;
  font-family: "Gilroy-Medium";
  width: 100%;
  height: 50px;
  padding: 14px;
  font-size: 16px;
  line-height: 50px;
  background: ${colors.GRAY_EXTRA_LIGHT};
  color: ${colors.BLACK};
  border: 0;
  border-radius: 3px;
  transition: all 200ms ease-in-out;
  text-overflow: ellipsis;
  -webkit-appearance: none;

  &::-webkit-input-placeholder {
    color: ${colors.GRAY_TEXT_MEDLIGHT};
  }

  &:-ms-input-placeholder {
    color: ${colors.GRAY_TEXT_MEDLIGHT};
  }

  &::placeholder {
    color: ${colors.GRAY_TEXT_MEDLIGHT};
  }

  &:focus {
    outline: none;
  }
`;

const Placeholder = styled.span`
  position: absolute;
  top: 25px;
  transform: translateY(-50%);
  font-size: 16px !important;
  padding: 14px;
  font-family: "Gilroy-Medium";
  color: ${colors.GRAY_TEXT_MEDLIGHT} !important;
  pointer-events: none;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  z-index: 10;

  sup {
    color: ${colors.PRIMARY_RED};
    font-size: 16px;
    position: relative;
    right: -3px;
    bottom: -5px;
    line-height: 0;
  }
`;

const Icon = styled.span`
  position: absolute;
  right: 14px;
  top: 25px;
  transform: translateY(-50%);
  z-index: 10;

  svg {
    display: block;
    z-index: 1;
    fill: ${colors.BLACK};
    cursor: pointer;
    width: 18px;
    height: 18px;
  }
`;

const ErrorMessageChar = styled(ErrorMessage)`
  margin-top: 15px;
`;

export default memo(FormInput);
